/* src/app/tip-ticket/pages/tip-ticket-new/tip-ticket-new.component.scss */
/*# sourceMappingURL=tip-ticket-new.component.css.map */
